import dynamic from 'next/dynamic'
import type { ComponentType } from 'react'

const HarlemHeightsMigration = dynamic(() => import('./region-1-migration'), { ssr: false })
const SwannanoaValleyMigration = dynamic(() => import('./region-2-migration'), { ssr: false })

export const migrationPlugins: Record<number, ComponentType | undefined> = {
  1: HarlemHeightsMigration,
  2: SwannanoaValleyMigration,
}
